export default "__VITE_ASSET__0009111f__"